import React from 'react';
import { useTranslation } from 'next-i18next';
import { LiveChatButton } from '../Features/CSDChat';

const SocialContainer = ({ siteName, layoutType }) => {
    const { t } = useTranslation();
    
    return (
        <div className="social-list">
            {
                layoutType === 'rightNav'
                    && (
                        <div className="social-list__header">
                            <span className="text">{t('lbl_LiveSupport')}</span>
                        </div>
                    )
            }
            <div className="social-list__item">
                <LiveChatButton
                    siteName={siteName}
                    layoutType={layoutType}
                >
                </LiveChatButton>
            </div>            
        </div>
    );
};

export default SocialContainer;
